export const urlTransform = (url, width = undefined, height = undefined) => {
    const cdnUrl = process.env.CDN_URL || '';
    if (!cdnUrl) {
        return url;
    }
    try {
        const cdnBase = new URL(cdnUrl);
        let finalUrl;
        try {
            const incoming = new URL(url);
            if (incoming.hostname === cdnBase.hostname) {
                // Ya tiene el CDN, trabajar sobre la misma URL
                finalUrl = incoming;
            }
            else {
                // Construir URL del CDN con image= apuntando a la URL original
                finalUrl = new URL(cdnBase.origin);
                finalUrl.searchParams.set('image', url);
            }
        }
        catch (_a) {
            // URL relativa o malformada, construir con CDN
            finalUrl = new URL(cdnBase.origin);
            finalUrl.searchParams.set('image', url);
        }
        if (width && !finalUrl.searchParams.has('width')) {
            finalUrl.searchParams.set('width', String(width));
        }
        if (height && !finalUrl.searchParams.has('height')) {
            finalUrl.searchParams.set('height', String(height));
        }
        return finalUrl.toString();
    }
    catch (_b) {
        return url;
    }
};
/**
 * Transform an array of rotator image URLs through the CDN optimizer.
 * Filters out falsy/empty entries.
 * @param urls  Raw rotator frame URLs
 * @param width CDN resize width (default 800, matching car-image convention)
 */
export const transformRotatorUrls = (urls, width = 800) => {
    return urls
        .filter((url) => !!url && url.trim() !== "")
        .map((url) => urlTransform(url, width));
};
